/**
 * Registration form business details translation keys
 */
export const REGISTRATION_EMPTY_BUSINESS_DETAILS_MESSAGE_TRANSLATION_KEY =
  'registration_form_business_details_message';
export const REGISTRATION_VIEWER_BUSINESS_DETAILS_MESSAGE_TRANSLATION_KEY =
  'registration_form_viewer_business_details_message';
export const REGISTRATION_VIEWER_BUSINESS_DETAILS_BALANCE_MESSAGE_TRANSLATION_KEY =
  'registration_form_viewer_business_details_balance_message';
